<template>
  <DModal v-if="isOpenModal" :showClose="false" @close="closeModal" class="d-modal standard-duration"
          :isBgOverlay="true">
    <template slot="insertComponent">
      <div class="d-modal__header">
        <h2>{{ $t('vue2.set_standard_duration.set_standard_duration_for_the_school') }}</h2>
        <div class="font-large icon__bg-circle d-modal__header__close" @click="closeModal"><span
          class="icon-cross2"></span></div>
      </div>
      <div class="d-modal__body">
        <div class="input-group">
          <label>{{ $t('vue2.set_standard_duration.standard_duration_for_the_school') }}</label>
          <div class="input-minutes-container">
            <input type="number" v-model="inputDuration" id="standard-duration-input" @focus="selectAllOnFocus($event)" ref="duration_input" maxlength="4">
            {{ $t('vue2.set_standard_duration.minutes') }}
          </div>
          <p v-if="!isAValidDuration" class="input-error">
            {{ $t('vue2.set_standard_duration.the_number_must_be_divisible_by_five') }} </p>
        </div>
        <h4 class="marg-2-top standard-duration__explained text-explainer" v-if="isForImportInZEN">
          {{ $t('vue2.set_standard_duration.set_standard_length_for_zen') }}
        </h4>
        <div class="marg-2-top" v-else>
          <ul class="disc">
            <li>{{ $t('vue2.set_standard_duration.this_setting_will_be_selected_if_nothing_else_is') }}</li>
            <li>{{ $t('vue2.set_standard_duration.standard_duration_can_be_selected_for_each_course') }}</li>
            <li>{{ $t('vue2.set_standard_duration.already_created_courses_want_be_updated') }}</li>
          </ul>
        </div>
        <div class="d-modal__buttons">
          <button class="marg-5-right" @click="closeModal">{{ $t('vue2.common.cancel') }}</button>
          <button class="submit-button submit-button--disabled" v-if="!isAValidDuration">
            {{ $t('vue2.common.save') }}
          </button>
          <button class="submit-button submit-button--danger bttn bttn--primary"
                  :class="{'bttn--loading': isButtonLoading}" @click="submit" v-else>{{
              $t('vue2.common.save')
            }}
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>

<script>
import DModal from '../common/DModal'
import docendo from '../../docendo'

export default {
  components: {DModal},
  props: {
    isOpenModal: {
      type: Boolean,
      default: false
    },
    isForImportInZEN: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      inputDuration: 0,
      isButtonLoading: false
    }
  },
  computed: {
    activeSchool () {
      return this.$store.state.activeSchool
    },
    originalDuration () {
      if (this.activeSchool && this.activeSchool.subject_default_duration) {
        return this.activeSchool.subject_default_duration
      }
    },
    isAValidDuration () {
      return /^-?[\d.]+(?:e-?\d+)?$/.test(this.inputDuration) && this.inputDuration > 0 && this.inputDuration < 1440 && this.inputDuration % 5 === 0
    }
  },
  watch: {
    isOpenModal (val) {
      if (val) {
        this.openModal()
      } else {
        this.closeModal()
      }
    }
  },
  methods: {
    selectAllOnFocus (evt) {
      setTimeout(_ => {
        evt.target.select()
      }, 0)
    },
    openModal () {
      this.inputDuration = this.originalDuration
      this.$nextTick(_ => {
        this.$refs.duration_input.focus()
      })
    },
    closeModal () {
      this.$emit('close')
    },
    submit () {
      this.isButtonLoading = true
      let updates = {subject_default_duration: this.inputDuration}
      docendo.updateSchool(window.SCHOOL.id, updates, success => {
        this.$store.commit('updateActiveSchoolDuration', success.subject_default_duration)
        this.$emit('close')
        this.$emit('submit')
        this.isButtonLoading = false
      }, failure => {
        console.log('failed')
      })
    }
  }
}
</script>

<style>
.standard-duration.d-modal {
  text-align: left;
}

ul.disc {
  list-style-type: disc;
  margin: 0 0 0 20px;
  line-height: 1.4;
}

ul.disc li {
  margin-bottom: 10px;
  list-style-type: disc;
}

.text-link:hover {
  text-decoration: underline;
}

.input-minutes-container {
  display: flex;
  align-items: center;
}

.input-minutes-container input {
  min-width: 100px;
  max-width: 100px;
  font-size: 16px;
  padding-left: 10px;
  text-align: center;
  margin-right: 10px;
}

.standard-duration .d-modal__body {
  width: 450px;
}

.standard-duration .bttn.bttn--primary {
  width: auto;
  height: auto;
}

.standard-duration .bttn.bttn--primary.bttn--loading {
  color: transparent !important;
}

.standard-duration .bttn.bttn--primary.bttn--loading:before {
  top: 4px;
  height: 12px;
  width: 12px;
}

#standard-duration-input {
  background: #ffffff;
}

.standard-duration__explained {
  line-height: 1.5;
}

</style>



// WEBPACK FOOTER //
// StandardDurationSetting.vue?ec4f832a